export default __webpack_public_path__ + "static/media/login-desing-1.20b60d2c.png";